import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router/index";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import Tooltip from "primevue/tooltip";
import ConfirmDialog from "primevue/confirmdialog";
import { PortalPreset } from "./mytheme.ts";
import { initSentry } from "./lib/sentry";

// Import styles
import "./style.css";
import "tailwindcss";
import "primeicons/primeicons.css";

// Create app instance
const app = createApp(App);

// Create Pinia store
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// Configure PrimeVue with proper theme
app.use(PrimeVue, {
  theme: {
    preset: PortalPreset,
    options: {
      prefix: "p",
      darkModeSelector: ".p-dark",
      cssLayer: false,
    },
  },
  ripple: true,
  unstyled: false,
});

// Use plugins
app.use(pinia);
app.use(router as any);
app.use(ConfirmationService);

// Register global components
app.component("ConfirmDialog", ConfirmDialog);

// Register directives
app.directive("tooltip", Tooltip);

// Initialise error tracking, performance & session replay (no-op without DSN)
initSentry(app, router);

// Mount app
app.mount("#app");